import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getQRCode } from '../../api/QRApi';

export const fetchQRCode = createAsyncThunk(
  'qrcode/fetchQRCode',
  async (__, { rejectWithValue }) => {
    try {
      const response = await getQRCode();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const qrCodeSlice = createSlice({
  name: 'qrcode',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Agar aapko koi sync actions chahiye
    clearQRCode: (state) => {
      state.data = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQRCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQRCode.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchQRCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearQRCode } = qrCodeSlice.actions;
export default qrCodeSlice.reducer;